import { render, staticRenderFns } from "./MusicCards.vue?vue&type=template&id=8b66a9ee&"
import script from "./MusicCards.vue?vue&type=script&lang=js&"
export * from "./MusicCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports